module.exports = __webpack_public_path__ + "img/24.62879228.png";